import { jsx as _jsx } from "react/jsx-runtime";
import { DescriptionList } from "../../../../DescriptionList";
import { DescriptionListItem } from "../../../../DescriptionListItem";
export var FormSummaryItem = function (props) {
    var title = props.title, value = props.value, valueSelector = props.valueSelector, selectedValue = props.selectedValue, error = props.error;
    return (_jsx(DescriptionList, { termWidth: 400, children: _jsx(DescriptionListItem, { term: title, description: valueSelector ? selectedValue : value, error: error }) }));
};
